import React, { Suspense, useEffect, useRef } from 'react';
import MainLayout from '../layoutfolder/MainLayout';
import PublicLayout from '../layoutfolder/PublicLayout';
import { useNavigate } from 'react-router-dom';
import { Amplify, Hub, Auth } from 'aws-amplify';
import { useSelector, useDispatch } from 'react-redux';
import { logIn, logOut, setGoogleUserLoginCompleted } from '../redux/reducers/login';
import { updateUserDetailsOnSignIn } from '../redux/reducers/userDetails';
import { skipOpen } from '../redux/reducers/companySkip.js';
import { fetchPaymentSettings } from '../redux/reducers/PaymentSettingsSlice.js';
import { fetchCompany } from '../redux/reducers/CompanySlice.js';
import { injectTokensIntoAmplify } from '../auth.ts';
import { API, graphqlOperation } from 'aws-amplify';
import { logOutStop, logoutStart } from '../redux/reducers/logout.js';
import { loginCognitoUser } from '../graphql/';
import { persistor } from '../redux/store';
import axios from 'axios';
import { fetchUserPreference } from '../redux/reducers/UserPreference';
import { getUserAttributes } from '../library/shared.js';
import { getCognitoUserSessions } from '../graphql/';
import config from '../aws-exports.js';
import { skipReset } from '../redux/reducers/companySkipSave.js';
import { resetNavigationState } from '../redux/reducers/controllNavigation.js';
import { onlogoutCognitoUser } from '../graphql/postgress_graphql';
import { VersionUpdateNotification } from '../features';
import { SkeletonLoader } from '../components';
import { postLogToLambda } from '../utils/logging';
import { tokenRefreshInDb } from '../pages/auth/tokenRefreshInDb';
import { validateUserSession } from '../pages/auth/validateUserSession';
import { fetchFeatureFlags } from '../redux/reducers/featureFlagSlice';

const PrivateRoutes = React.lazy(() => import('./PrivateRoutes.jsx'));
const PublicRoutes = React.lazy(() => import('./PublicRoutes.jsx'));
console.log(config);
const origin = window.location.origin;
const InDomain = 'https://in.ledgerx.biz/';
console.log({ origin });
if (origin === 'https://in.ledgerx.biz') {
  config.oauth.redirectSignIn = InDomain;
  config.oauth.redirectSignOut = 'https://in.ledgerx.biz/logout';
}
console.log({ config });
Amplify.configure(config);

const Routesmap = ({ nav }) => {
  const { loginStatus, isLogingOut } = useSelector((state) => state.loginActions);

  const companyReducer = useSelector((state) => state.companyReducer);
  console.log(companyReducer, 'companyReducer');
  // const { data: companyList, isLoading, isError, error } = useFetchCompanylistQuery();

  const userPreferenceAndFY = useSelector((state) => state.userPrefrenceandReducer);

  const { isBlocked } = useSelector((state) => state.controllNavigationSlice);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  let callback = () => dispatch(logIn());
  const constructLogoutUrl = (config) => {
    const cognitoDomain = config.oauth.domain;
    const clientId = config.aws_user_pools_web_client_id;
    const signoutUrl = config.oauth.redirectSignOut;
    return `https://${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${signoutUrl}`;
  };
  const handleSignout = async (data) => {
    console.log('logg', JSON.stringify(data.value));
    let incomingsession = data.value.data.onlogoutCognitoUser.linkedsessionid;
    console.log('incomingsession', incomingsession);
    const currentsession = localStorage.getItem('deviceKey');
    console.log('currentsession', currentsession);

    if (incomingsession == currentsession) {
      return;
    } else {
      postLogToLambda('another session found' + JSON.stringify({ data, currentsession }), 'routes map');
      return navigate('/new-login-detected');
    }
    let sessions = await API.graphql(graphqlOperation(getCognitoUserSessions));

    if (sessions?.data?.getCognitoUserSessions?.length) {
      const currentSessionId = localStorage.getItem('deviceKey');
      const currentSession = sessions.data.getCognitoUserSessions.find((session) => session?.linkedsessionid == currentSessionId);
      if (currentSession) {
        return;
      } else {
        postLogToLambda(JSON.stringify({ data, currentSessionId, currentSession, sessions }), 'routesmap 2');
      }
    }
    postLogToLambda(JSON.stringify({ data, sessions }), 'routesmap 1');
    const devicekey = localStorage.getItem('deviceKey');

    console.log({ sessions, key: devicekey });
    let accessToken = null;
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);

      if (key.startsWith('CognitoIdentityServiceProvider') && key.endsWith('.accessToken')) {
        accessToken = localStorage.getItem(key);
        break;
      }
    }
    if (accessToken) {
      // const option = {
      //   method: "POST",
      //   url: API_ENDPOINTS.REACT_APP_GLOBAL_SIGNOUT_URL,
      //   headers: { Authorization: accessToken },
      // };
      // axios(option).catch((err) => {
      //   console.log(err);
      // });
    }
    const logouturl = constructLogoutUrl(config);
    axios.get(logouturl);
    persistor.purge(); // purge redux
    dispatch(skipReset());
    dispatch(logoutStart());
    try {
      localStorage.clear();
      const cookies = document.cookie.split(';');
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i];
        const eqPos = cookie.indexOf('=');
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
      }
      dispatch(logOut());

      dispatch(logOutStop());
      localStorage.removeItem('emailID');
      localStorage.removeItem('mobileNo');
    } catch (error) {
      dispatch(logOutStop());
    }
  };

  useEffect(() => {
    let subscription;

    const setupSubscription = async () => {
      if (loginStatus) {
        try {
          const user = await getUserAttributes();
          console.log({ user });
          if (!user?.sub) {
            navigate('/session-expired?6');
            return;
          }
          subscription = API.graphql(
            graphqlOperation(onlogoutCognitoUser, {
              cognitousername: user.sub,
            })
          ).subscribe({
            next: (data) => {
              handleSignout(data);
            },
            error: (error) => console.log(error),
          });
          console.log({ subscription });
        } catch (error) {
          console.error('Error setting up subscription:', error);
          if (
            error?.name === 'NotAuthorizedException' ||
            error?.code === 'NotAuthorizedException' ||
            String(error?.message || '').includes('Access Token has been revoked')
          ) {
            navigate('/session-expired?7');
          }
        }
      }
    };

    setupSubscription();

    return () => subscription?.unsubscribe();
  }, [loginStatus]);
  useEffect(() => {
    if (companyReducer?.Loaded && companyReducer?.companyDetails && userPreferenceAndFY?.render && !userPreferenceAndFY?.loading) {
      dispatch(fetchUserPreference());
    }
  }, [companyReducer, userPreferenceAndFY?.render]);

  const subscriptionsRef = useRef([]);

  // useEffect(() => {
  //   if (
  //     !loginStatus ||
  //     !userPreferenceAndFY?.userPreference ||
  //     !companyReducer?.companyDetails
  //   )
  //     return;

  //   const userID = userPreferenceAndFY.userPreference[0]?.UserID;
  //   const companyID = companyReducer?.companyDetails?.CompanyID;

  //   if (!userID || !companyID) return;

  //   const subscriptions = [];

  //   const addSubscription = (config, variables, callback) => {
  //     subscriptions.push(
  //       API.graphql(graphqlOperation(config, variables)).subscribe({
  //         next: callback,
  //         error: (error) =>
  //           console.error(`Error in subscription: ${config.name}`, error),
  //       })
  //     );
  //   };

  //   ["SelectedFinYear"].forEach((attribute) =>
  //     addSubscription(
  //       oncreateUserPreference,
  //       { UserID: userID, AttributeTypeCD: attribute },
  //       () => {
  //         dispatch(balanceSheetApi.util.invalidateTags(["BalanceSheetData"]));
  //         dispatch(trialBalanceApi.util.invalidateTags(["TrialBalanceData"]));
  //         dispatch(profitNLossApi.util.invalidateTags(["ProfitNLossData"]));
  //         dispatch(fetchUserPreference());
  //         dispatch(resetBusinessOverViewState());
  //         dispatch(setResetOpeningBalance());
  //       }
  //     )
  //   );

  //   // List of subscription configurations with shared dispatch actions
  //   const commonSubscriptions = [
  //     oncreateSalesInvoice,
  //     oncreatePurchaseInvoice,
  //     onCreateAccountMaster,
  //     oncreateTransactionDetailsArray,
  //     oncreateAccountOpeningBalancesTransaction,
  //     onCreateTransactionMaster,
  //     ondeleteTransactionMaster,
  //     onupdateAccountMaster,
  //     ondeleteAccountMaster,
  //     onCreateAccountGroupMaster,
  //     onupdateAccountGroupMaster,
  //     ondeleteAccountGroupMaster,
  //     oncreateItemTransaction,
  //     oncreateItemCategorymaster,
  //     oncreateBankDetails,
  //     oncreatePartyTransaction,
  //     oncreateCrDrNoteTransactionsArray,
  //     oncreateTransactionWithSpecificTime,
  //     onupdateItemmaster,
  //     ondeleteItemmaster,
  //     onCreateItemmaster,
  //   ];

  //   // Subscribe to each config and dispatch shared actions on data change
  //   commonSubscriptions.forEach((config) =>
  //     addSubscription(config, { CompanyID: companyID }, () => {
  //       dispatch(balanceSheetApi.util.invalidateTags(["BalanceSheetData"]));
  //       dispatch(trialBalanceApi.util.invalidateTags(["TrialBalanceData"]));
  //       dispatch(profitNLossApi.util.invalidateTags(["ProfitNLossData"]));
  //       dispatch(resetBusinessOverViewState());
  //       dispatch(setResetOpeningBalance());
  //       dispatch(setItemStockSummaryReRender());
  //       if (config === onCreateAccountGroupMaster)
  //         dispatch(listGroupMasterApi.util.invalidateTags(["listGroupMaster"]));
  //     })
  //   );

  //   subscriptionsRef.current = subscriptions;
  //   return () => subscriptionsRef.current.forEach((sub) => sub?.unsubscribe());
  // }, [loginStatus, userPreferenceAndFY, companyReducer, dispatch]);

  const sos = () => {
    const accessToken = new URLSearchParams(window.location.search).get('token');
    const idToken = new URLSearchParams(window.location.search).get('idToken');
    const refreshToken = new URLSearchParams(window.location.search).get('refreshToken');
    console.log({ accessToken, idToken, refreshToken });
    if (accessToken) {
      console.log('call');
      injectTokensIntoAmplify(accessToken, idToken, refreshToken, callback);
    }
  };

  let themeFetch = () => {
    // if (loginStatus) {
    //   const fetchUserThemePreference = async () => {
    //     try {
    //       const response = await API.graphql(
    //         graphqlOperation(listUserPreference)
    //       );
    //       let attributeValue = response.data.listUserPreference.find((e) => e.attributetypecd === "SideBarPin").attributevalue
    //       // const attributeValue =
    //       //   response?.data?.getUserThemePreference?.attributevalue;
    //       if (attributeValue !== theme?.palette?.TmId.id) {
    //         // setTimeout(() => {
    //         Themefn(attributeValue);
    //         // }, 1500);
    //       }
    //     } catch (error) {
    //       console.log("error", error);
    //     } finally {
    //       // Any final actions if needed
    //     }
    //   };
    //   // Call the async function
    //   fetchUserThemePreference();
    // }
  };
  const FetchData = async () => {
    try {
      dispatch(fetchPaymentSettings());
      dispatch(fetchCompany());
      dispatch(resetNavigationState());
      let userData = await getUserAttributes();
      console.log({ userData });
      dispatch(updateUserDetailsOnSignIn(userData));
    } catch (e) {
      console.log(e, 'error');
      if (
        e?.name === 'NotAuthorizedException' ||
        e?.code === 'NotAuthorizedException' ||
        String(e?.message || '').includes('Access Token has been revoked')
      ) {
        navigate('/session-expired?5');
        return;
      }
    } finally {
      themeFetch();
    }
  };

  useEffect(() => {
    if (loginStatus && isLogingOut === false) {
      FetchData();
    }

    return () => {};
  }, [loginStatus, isLogingOut]);

  // Session refresh logic - call tokenRefreshInDb when user is inactive for more than 5 minutes 10 seconds
  useEffect(() => {
    if (!loginStatus) {
      // Clear timer and global function when user logs out
      if (window.sessionRefreshTimer) {
        clearTimeout(window.sessionRefreshTimer);
        window.sessionRefreshTimer = null;
      }
      if (window.resetSessionRefreshTimer) {
        delete window.resetSessionRefreshTimer;
      }
      return;
    }

    const REFRESH_INTERVAL = 5 * 60 * 1000 + 10 * 1000; // 5 minutes 10 seconds

    const resetSessionRefreshTimer = () => {
      if (window.sessionRefreshTimer) {
        clearTimeout(window.sessionRefreshTimer);
      }

      window.sessionRefreshTimer = setTimeout(async () => {
        console.log('User has been inactive for 5 minutes 10 seconds, refreshing session in DB...');
        let sp = await validateUserSession();
        if (!sp.isValid) {
          postLogToLambda('invalid session in db when refreshing token on random check', 'routesmap 2');
          navigate('/session-expired?3');
        }
        // Reset timer for next cycle
        resetSessionRefreshTimer();
      }, REFRESH_INTERVAL);
    };

    // Make function globally accessible for tokenRefresh event
    window.resetSessionRefreshTimer = resetSessionRefreshTimer;

    // Start the initial timer
    resetSessionRefreshTimer();

    // Cleanup when loginStatus changes
    return () => {
      if (window.sessionRefreshTimer) {
        clearTimeout(window.sessionRefreshTimer);
        window.sessionRefreshTimer = null;
      }
      if (window.resetSessionRefreshTimer) {
        delete window.resetSessionRefreshTimer;
      }
    };
  }, [loginStatus]);

  useEffect(() => {
    sos();
    checkIfAuthenticated();

    // Set up localStorage change listener for cross-tab logout
    const handleStorageChange = (event) => {
      if (event.key === 'logoutTrigger' && event.newValue) {
        console.log('Logout trigger detected in localStorage:', event.newValue);

        // Check if we're not already on logout page
        const currentPath = window.location.pathname;
        if (currentPath !== '/logout') {
          console.log('Performing cross-tab logout cleanup...');

          // Purge redux store - this handles all state cleanup and navigation
          persistor.purge();
        } else {
          console.log('Ignoring logout trigger - already on logout page');
        }
      }
    };

    // Listen for localStorage changes
    window.addEventListener('storage', handleStorageChange);
    console.log('Cross-tab logout listener set up (localStorage)');

    Hub.listen('auth', async (data) => {
      console.log({ data });
      switch (data.payload.event) {
        case 'signIn':
          // dispatch(updateUserDetailsOnIn(data?.payload?.data?.storage?.email));
          let datas = {
            userName: data?.payload?.data?.attributes?.name || data.payload.data.signInUserSession.idToken.given_name,
            email: data?.payload?.data?.attributes?.email,
            designation: data?.payload?.data?.attributes?.['custom:Designation'],
          };

          localStorage.setItem('UserName', data?.payload?.data?.attributes?.name || data.payload.data.signInUserSession.idToken.given_name);

          // Store the current login time
          localStorage.setItem('loginTime', new Date().toISOString());
          break;
        case 'cognitoHostedUI':
          dispatch(logIn());
          Auth.currentSession()
            .then((data) => {
              let idToken = data.getIdToken();
              let email = idToken.payload.email;
            })
            .catch((err) => console.log(err));
          const devicekey = Date.now()?.toString();
          localStorage.setItem('deviceKey', devicekey);
          let createSession = await API.graphql(
            graphqlOperation(loginCognitoUser, {
              LinkedSessionID: devicekey,
            })
          );
          dispatch(setGoogleUserLoginCompleted());
          console.log({ createSession });
          localStorage.setItem('sessionID', createSession.data?.loginCognitoUser?.[0]?.sessionid);
          localStorage.setItem('emailID', data?.payload?.data?.storage?.email);

          // Store the current login time
          localStorage.setItem('loginTime', new Date().toISOString());

          // dispatch(updateUserDetailsOnIn(data?.storage?.email));

          break;
        case 'signUp':
          break;
        case 'confirmSignUp':
          dispatch(skipOpen());
          localStorage.setItem('sidebarNavbar', 'yes');

          break;
        case 'signOut':
          break;
        case 'oAuthSignOut':
          break;
        case 'resendSignUp':
          break;
        case 'tokenRefresh': {
          console.log('Token refresh event detected, attempting to refresh session in DB...');
          // Call tokenRefreshInDb and only reset timer if successful
          try {
            const success = await tokenRefreshInDb();
            if (success) {
              console.log('Session refresh successful, resetting timer...');
              // Reset the session refresh timer since user is active and session refreshed
              if (window.resetSessionRefreshTimer) {
                window.resetSessionRefreshTimer();
              }
            } else {
              postLogToLambda('invalid session in db when refreshing token', 'routesmap 1');
              navigate('/session-expired?4');
            }
          } catch (error) {
            console.log('Session refresh error:', error);
          }
          break;
        }
        default:
          break;
      }
    });

    // Cleanup function
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);

  const checkIfAuthenticated = async () => {
    let currentSession = null;
    try {
      currentSession = await Auth.currentSession();

      localStorage.setItem('email', currentSession.idToken.payload.email);
    } catch (err) {}
  };

  useEffect(() => {
    dispatch(fetchFeatureFlags());
  }, [dispatch, loginStatus]);
  
  return loginStatus === true ? (
    <MainLayout nav={nav}>
      <Suspense fallback={<SkeletonLoader />}>
        <PrivateRoutes />
      </Suspense>
      <VersionUpdateNotification />
    </MainLayout>
  ) : (
    <PublicLayout>
      <Suspense fallback={<SkeletonLoader />}>
        <PublicRoutes />
      </Suspense>
    </PublicLayout>
  );
};
export default Routesmap;
